"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countWith = exports.count = void 0;

var _isMatch = require("../is-match/is-match");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var byFn = function byFn(fn) {
  return function (source) {
    var _count = 0;

    for (var i = 0, length = source.length; i < length; i++) {
      if (fn.call(null, source[i]) === true) {
        _count = _count + 1;
      }
    }

    return _count;
  };
};

var byObject = function byObject(source) {
  var result = 0;
  var key;

  for (key in source) {
    if (source.hasOwnProperty(key)) {
      result = result + 1;
    }
  }

  return result;
};
/**
 * Count the number of elements that satisfies a function
 *
 * @tag Array
 * @signature (fn: Function)(source: Array <Object>): number
 *
 * @param  {Function}  fn      Match function
 * @param  {Object[]}  source  Source array
 *
 * @return  {number}
 *
 * @example
 * const scores = [{
 *  name   : "Bob",
 *  score  : 1,
 *  subject: "Math"
 * }, {
 *  name   : "Alice",
 *  score  : 10,
 *  subject: "Math"
 * }, {
 *  name   : "Hatter",
 *  score  : 10,
 *  subject: "Math"
 * }]
 *
 * count(element => element.score === 10)(scores)
 * // => 2
 */


var count = function count(fn) {
  var type = Array.isArray(fn) ? "array" : _typeof(fn);

  switch (type) {
    case "array":
    case "string":
      return fn.length;

    case "function":
      return byFn(fn);

    case "object":
      return fn === null ? 0 : byObject(fn);

    default:
      return 0;
  }
};

exports.count = count;

var countWith = function countWith(subset) {
  return count((0, _isMatch.isMatch)(subset));
};

exports.countWith = countWith;